<template>
  <CommonAddon>
    <template #unassign>
      <subtitle :sub-title='getUnassignTxt' />
      <subtitle :sub-title="getUnassignTxt2" />
      <div>
        <user-management-cta is-seat-manage :cta-name="$t('billing.success.seat_management')" />
        <view-account type='plain' />
      </div>
    </template>
    <template #upsell>
      <subtitle :sub-title="$t('billing.success.confirmation.user_assign_desc')" />
      <user-management-cta is-seat-manage :cta-name="$t('billing.success.confirmation.user_cta')" />
    </template>
  </CommonAddon>
</template>
<script>
import CommonAddon from '@/views/succezz/components/common-addon.vue';
import UserManagementCta from '@/views/succezz/thanks-template/user-management-cta.vue';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';

export default {
  components: { Subtitle, ViewAccount, UserManagementCta, CommonAddon },
  mixins: [CommonAddon],
  computed: {
    getUnassignTxt() {
      return this.$t('billing.success.downgrade_seat_licenses_hub', [this.unassignLicenses, this.billingDate]);
    },
    getUnassignTxt2(){
      return this.$t('billing.success.downgrade_seat_hub_process');
    },
  },
};
</script>
